export class authenticateModel {
    AuthToken1: number;
    AuthToken2: number;
    AuthToken3: number;
    AuthToken4: number;
    AuthToken5: number;
    AuthToken6: number;
    AuthToken: string;
}